import type { VsmContext, MasterPageConfigEntry, MasterPageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { EnvironmentServiceMasterPageConfig } from '../types'
import { name } from '../symbols'

const environmentServiceMasterPageConfig: MasterPageConfigFn<EnvironmentServiceMasterPageConfig> = ({
	api,
}: VsmContext) => {
	const languageDirection = api.env.getLanguageDirectionWithOptInRtlSupport()
	return {
		languageDirection,
	}
}

export const masterPageConfig: MasterPageConfigEntry<EnvironmentServiceMasterPageConfig> = {
	name,
	configFactory: environmentServiceMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
